import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPanel = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.5 7.25C8.08579 7.25 7.75 7.58579 7.75 8C7.75 8.41421 8.08579 8.75 8.5 8.75H15.5C15.9142 8.75 16.25 8.41421 16.25 8C16.25 7.58579 15.9142 7.25 15.5 7.25H8.5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2.75 6.5C2.75 4.42893 4.42893 2.75 6.5 2.75H17.5C19.5711 2.75 21.25 4.42893 21.25 6.5V17.5C21.25 19.5711 19.5711 21.25 17.5 21.25H6.5C4.42893 21.25 2.75 19.5711 2.75 17.5V6.5ZM6.5 4.25C5.25736 4.25 4.25 5.25736 4.25 6.5V17.5C4.25 18.7426 5.25736 19.75 6.5 19.75H17.5C18.7426 19.75 19.75 18.7426 19.75 17.5V6.5C19.75 5.25736 18.7426 4.25 17.5 4.25H6.5Z",
		fill: "currentColor"
	})]
});
export { SvgIconPanel as ReactComponent };
